import { apiQueryAdapter } from "../apiQueryAdapter";
import { PageResponseModel } from "../common/models";
import {
  CarrierAssignmentChangeLogFilterModel,
  CarrierAssignmentChangeLogItem,
} from "./models";

const PAGE_SIZE = 50;

class CarrierAssignmentChangeLogService {
  private static instance: CarrierAssignmentChangeLogService;

  static getInstance(): CarrierAssignmentChangeLogService {
    if (!CarrierAssignmentChangeLogService.instance) {
      CarrierAssignmentChangeLogService.instance = new CarrierAssignmentChangeLogService();
    }
    return CarrierAssignmentChangeLogService.instance;
  }

  /**
   * Fetch carrier assignment change history for a Static Load lane (planId).
   * GET /carrier-assignment-changes/by-lane/{planId}
   */
  public getByPlanId = async (
    planId: string | number,
    filter: CarrierAssignmentChangeLogFilterModel = {},
    page = 0
  ): Promise<PageResponseModel<CarrierAssignmentChangeLogItem>> => {
    const params: Record<string, string | number> = {
      page,
      size: PAGE_SIZE,
    };
    if (filter.dateFrom) params.dateFrom = filter.dateFrom;
    if (filter.dateTo) params.dateTo = filter.dateTo;

    const response = await apiQueryAdapter.query<
      PageResponseModel<CarrierAssignmentChangeLogItem>
    >(`/carrier-assignment-changes/by-lane/${planId}`, "GET", { params });

    return response.data;
  };

  /**
   * Search assignment change logs (Load Board uses sourceType=LOAD_BOARD).
   * GET /carrier-assignment-changes
   */
  public search = async (
    filter: CarrierAssignmentChangeLogFilterModel = {},
    page = 0
  ): Promise<PageResponseModel<CarrierAssignmentChangeLogItem>> => {
    const params: Record<string, string | number> = {
      page,
      size: PAGE_SIZE,
    };
    if (filter.sourceType) params.sourceType = filter.sourceType;
    if (filter.search) params.search = filter.search;
    if (filter.carrierNumber) params.carrierNumber = filter.carrierNumber;
    if (filter.dateFrom) params.dateFrom = filter.dateFrom;
    if (filter.dateTo) params.dateTo = filter.dateTo;

    const response = await apiQueryAdapter.query<
      PageResponseModel<CarrierAssignmentChangeLogItem>
    >("/carrier-assignment-changes", "GET", { params });

    return response.data;
  };
}

export default CarrierAssignmentChangeLogService.getInstance();
